///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq = abcsetup.rfq || {};
abcsetup.rfq.bid_requests = abcsetup.rfq.bid_requests || {};
abcsetup.rfq.bid_requests.create = abcsetup.rfq.bid_requests.create || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.bid_requests.create = {
    init: function () {
        CKEDITOR.create(document.getElementById('html'), CKEDITOR.config);

        abcsetup.setTitle('Add RFQ Event');

        // Init the common lib
        abcsetup.rfq.bid_requests.common.init();

        // Auto-select "Supply Issues" bid type after we select formulary type, if we're creating this RFQ Event for a supply issue.
        // The showIfs are running after this onchange event in my browser.
        // This means we don't know which "Supply Issue" bid type we should select when this runs.
        // So, we're crossing our fingers that the showifs will be done after a certain amount of time and we will then select the correct one for the current formulary type.
        let hackyAutoSelectSupplyIssueTimeoutID;
        let hackyAutoSelectSupplyIssueWaitMs = 500;
        $('#formulary_type').on('change', () => {
            window.clearTimeout(hackyAutoSelectSupplyIssueTimeoutID);
            const BidTypeSelect = $('#rfq_bid_type_id').trigger('change');

            // Reset the bid type dropdown if the option is no longer available
            setTimeout(function() {
                if ($('#rfq_bid_type_id').val() && BidTypeSelect.find('option[value="' + $('#rfq_bid_type_id').val() + '"]').hasClass('showIfHide')) {
                    BidTypeSelect.val(null);
                }
            }, 500);

            const for_supply_issue = String($('[name=rfq_supply_issue_ids]').first().val() || '').length > 0;
            if (for_supply_issue) {
                window.setTimeout(() => {
                    const supply_issue_id = BidTypeSelect.find('option:not(.showIfHide):contains("Supply Issues")').first().attr('value');
                    BidTypeSelect.val(supply_issue_id).trigger('change');
                }, hackyAutoSelectSupplyIssueWaitMs);
            }
        });

        // Start date was changed
        $('#start_date').bind('change', function () {
            if (abcsetup.userRole && abcsetup.userRole.class=='abc_swiss'){
                $('#pre_close_date').val(momentBusinessDays($(this).val(), 'YYYY-MM-DD').businessAdd(5).format('YYYY-MM-DD'));
                $('#close_date').val(momentBusinessDays($(this).val(), 'YYYY-MM-DD').businessAdd(10).format('YYYY-MM-DD'));
            } else {
                $('#close_date').val(momentBusinessDays($(this).val(), 'YYYY-MM-DD').businessAdd(3).format('YYYY-MM-DD'));
            }
        });

        $(document).on('change keyup', '#start_immediately', function(e) {
            if ($(this).is(":checked")) {
                $('#send_emails_immediately_div').removeClass('d-none');
            }

            if (! $(this).is(":checked")) {
                $('#send_emails_immediately').prop('checked', false);
                $('#send_emails_immediately_div').addClass('d-none');
                $('#editEmailText').addClass('d-none');
            }
        })

        $(document).on('change keyup', '#send_emails_immediately', function(e) {
            if ($(this).is(":checked")) {
                $('#editEmailTemplateModal').modal();
                $('#editEmailText').removeClass('d-none');
            }

            if (! $(this).is(":checked")) {
                $('#editEmailText').addClass('d-none');
            }
        });

        $('#create_rfq_bid_form').on('submit', function(e){
            if (! $('#send_emails_immediately').is(":checked")) {
                $('#html').val(null); //dont submit template to the backend if they dont want to send emails right away
            }
        });

        // Adjust the min date based on value
        if ($('#start_date').val() > $('#start_date').attr('min')) {
            $('#start_date').attr('min', $('#start_date').val());
        }

        // Bid type changed
        $('#gcn_family, #rfq_bid_type_id, #start_date, #suppliers, #incumbents, #customer').on('change', function () {

            // if ($(this).val() != '') {
                var gcn_family = '';
                if ($('#gcn_family').val() != '') {
                    gcn_family = $('#gcn_family').val();
                }

                var rfq_bid_type_id = '';
                var rfq_bid_type_name = '';
                if ($('#rfq_bid_type_id').val() != '') {
                    rfq_bid_type_name = $("#rfq_bid_type_id option:selected").text();
                    rfq_bid_type_id = $("#rfq_bid_type_id option:selected").val();
                }

                var suppliers = '';
                if ($('#suppliers').val() != '') {
                    suppliers = $("#suppliers option:selected").text().replace(/ *\([^)]*\) */g, "");
                }

                var incumbents = '';
                if ($('#incumbent_suppliers_table tr.item').length) {
                    incumbents = $.trim($('#incumbent_suppliers_table tr.item').first().find("td").eq(3).html());
                }

                var customer = '';
                if ($('#customer').val() != '') {
                    customer = $('#customer').val().replace(/[^a-z0-9\s\&\.\/]/gi, '');
                    $('#customer').val(customer);
                }

                //Bid type 23 (secondary add) should be populating with incumbent supplier info per SS #43
                if (rfq_bid_type_id == '24' || rfq_bid_type_id == '23') {
                    // show the incumbent name
                    var name = rfq_bid_type_name + ' :: ' + incumbents + ' - ' + $('#start_date').val();
                    $('#name').val(name);
                } else if (rfq_bid_type_id == '25') {
                    var rfq_formulary_type = '';
                    if ($('#formulary_type').val() != '') {
                        rfq_formulary_type = $("#formulary_type option:selected").text();
                    }
                    var name = rfq_formulary_type + ' :: ' + rfq_bid_type_name + ' :: ' + gcn_family + ' - ' + $('#start_date').val();
                    $('#name').val(name);
                // New Incremental Monthly RFQ Bid Type (id 29) auto generated name needs "Customer Name" instead of gcn family, incumbents or suppliers
                } else if (rfq_bid_type_id == '29') {
                    var rfq_formulary_type = '';
                    if ($('#formulary_type').val() != '') {
                        rfq_formulary_type = $("#formulary_type option:selected").text();
                    }
                    var name = rfq_formulary_type + ' :: Incremental Monthly Usage :: ' + customer + ' - ' + $('#start_date').val();
                    $('#name').val(name);
                } else {
                    // if ($('#gcn_family').val() != '' && $('#rfq_bid_type_id').val() != '') {
                    var name = rfq_bid_type_name + ' :: ' + gcn_family + ' - ' + $('#start_date').val();
                    $('#name').val(name);
                    // }
                }
            // }
        });
        // Used to create a PharmaGen Formulary - PRxO Incumbent from  PharmaGen Formulary - PharmaGen Incumbent.
        $(document).on('click', '.btn.submit', function (e) {
            if ($('input[name="converted_from_id"]').val() && $('#rfq_bid_type_id').val() == '16') {
                e.preventDefault();
                var _this = $(this);
                abcsetup.alerts.confirm('Create PharmaGen Formulary Synergy - PRxO Incumbent', 'Stop! Did you make sure the PRxO DNAC is correct? If No, please update prior to creating, otherwise click Yes to create event', function (resp) {
                    if (resp) {
                         $('form.rfq-requests').submit();
                    }
                });
            }
        });

        abcsetup.rfq.bid_requests.batch_import.init();
    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function () {
        $('#all_suppliers, #rfq_bid_type_id').trigger('change');
    },

    /**
     * _jquery.uploader
     *      An upload is complete this is the callback
     */
    uploadDone: function () {
        // Import the specified items
        if (abcsetup.uploader.uploadResult.type === 'items') {
            abcsetup.rfq.bid_requests.common.importItems(abcsetup.uploader.uploadResult.vals);
        } else {
            abcsetup.rfq.bid_requests.common.importSuppliers(abcsetup.uploader.uploadResult.vals);
        }
    },
}
